"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskProductsTableConfig = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const use_selected_tree_node_for_task_view_hook_1 = require("../../../hooks/use-selected-tree-node-for-task-view.hook");
const products_table_constants_1 = require("../products-table.constants");
const use_column_config_hook_1 = require("./use-column-config.hook");
const product_table_1 = require("../../../../../common/product-table");
const table_columns_1 = require("../../../../../common/table-columns");
const attributes_1 = require("../../../../../constants/attributes");
const cells_1 = require("../../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/cells");
const use_get_attributes_as_columns_1 = require("../../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/client/use-get-attributes-as-columns");
const hooks_1 = require("../../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/hooks");
const constants_1 = require("../../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/hooks/constants");
const localization_1 = require("../../../../../../localization");
const store_1 = require("../../../../../../store");
const getCellValues = (row, pathPrefix, label) => { var _a, _b; return ((_b = (_a = row[pathPrefix]) === null || _a === void 0 ? void 0 : _a[label]) !== null && _b !== void 0 ? _b : []); };
const useTaskProductsTableConfig = ({ onActiveProductIdChange, dynamicTableColumns, isCellLoading = () => false, isCellSynced = () => false, isCellFailed = () => false, isRowDisabled, onReviewStatusChange, isCellAutoOpen, onCellSubmit, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeNodeForTaskView = (0, use_selected_tree_node_for_task_view_hook_1.useSelectedTreeNodeForTaskView)();
    const { id: productTreeNodeIdForTaskView } = productTreeNodeForTaskView !== null && productTreeNodeForTaskView !== void 0 ? productTreeNodeForTaskView : {};
    const getColumnFilterConfig = (0, hooks_1.useColumnFilterConfig)(productTreeNodeIdForTaskView);
    const { excludedColumns, excludedLabelColumns, excludedMeasureColumns, columnsOrder, filterOptions, selectAllMode, checkIsColumnSelected, reviewAttribute, actions, } = dynamicTableColumns;
    const productsTableColumnsConfig = (0, use_column_config_hook_1.useColumnConfig)({
        attributeId: reviewAttribute === null || reviewAttribute === void 0 ? void 0 : reviewAttribute.id,
        onActiveProductIdChange,
        isCellLoading,
        isRowDisabled,
        onReviewStatusChange,
    });
    const productAttributeFilter = (0, react_1.useMemo)(() => {
        if (!excludedLabelColumns.length && selectAllMode) {
            return null;
        }
        let newExcludedLabelColumns = [];
        // base fields should be always displayed
        if (selectAllMode) {
            newExcludedLabelColumns = (0, ramda_1.without)(attributes_1.BASE_ENRICHED_ATTRIBUTES, excludedLabelColumns);
        }
        else {
            newExcludedLabelColumns = (0, ramda_1.uniq)([
                ...excludedLabelColumns,
                ...attributes_1.BASE_ENRICHED_ATTRIBUTES,
            ]);
        }
        const attributesFilter = !selectAllMode
            ? { in: newExcludedLabelColumns }
            : { notIn: newExcludedLabelColumns };
        return { label: attributesFilter };
    }, [excludedLabelColumns, selectAllMode]);
    const productMeasureFilter = (0, react_1.useMemo)(() => {
        if (!excludedMeasureColumns.length) {
            return null;
        }
        const attributesFilter = !selectAllMode
            ? { in: excludedMeasureColumns }
            : { notIn: excludedMeasureColumns };
        return { some: { dimension: attributesFilter } };
    }, [excludedMeasureColumns, selectAllMode]);
    const { isLoading, error, attributes } = (0, use_get_attributes_as_columns_1.useGetAttributesAsColumns)({
        catalogId,
        productTreeNodeId: productTreeNodeIdForTaskView,
        productAttributeFilter,
        productMeasureFilter,
        filterOptions,
    });
    const createColumn = (0, react_1.useCallback)((attributeColumn, columnConfig, attributeId, dataMeta, isAttributeEditable, pathPrefix) => {
        const { id, label } = attributeColumn;
        const { isAIEnriched, isMeasure } = dataMeta;
        if (columnConfig) {
            return columnConfig;
        }
        const baseColumn = Object.assign({ headerName: label, renderHeader: (0, product_table_1.getColumnHeader)(id), field: id, valueGetter: (_, row) => getCellValues(row, pathPrefix, label), width: 240, minWidth: 48, resizable: true, editable: isAttributeEditable && !isMeasure }, getColumnFilterConfig(id));
        // Handle original attribute columns with date/array formatting
        const isOriginalAttributeColumn = pathPrefix === 'labels'
            && !isAIEnriched
            && !isMeasure;
        if (isOriginalAttributeColumn) {
            return Object.assign(Object.assign({}, baseColumn), { valueGetter: (_, row) => getCellValues(row, pathPrefix, label), valueFormatter: product_table_1.formatOriginalCellValue });
        }
        return Object.assign(Object.assign({}, baseColumn), (!isAIEnriched && !isMeasure ? ({}) : ({
            // Use custom AttributeTagsViewCell for view mode with Unknown styling
            valueFormatter: (params) => {
                if (!params || params.length === 0) {
                    return [];
                }
                // Convert values to labels using options
                const labels = params.map((tagValue) => {
                    if (tagValue === attributes_1.SpecialAttributeValue.NotApplicable) {
                        return t({ key: attributes_1.SpecialAttributeValueToLocalizationKey[attributes_1.SpecialAttributeValue.NotApplicable] });
                    }
                    return tagValue;
                });
                return labels;
            },
            renderCell: (params) => { var _a; return (react_1.default.createElement(cells_1.AttributeTagsViewCell, { tags: params.formattedValue || [], disabled: (_a = isRowDisabled === null || isRowDisabled === void 0 ? void 0 : isRowDisabled(params.row)) !== null && _a !== void 0 ? _a : false, isSyncing: isCellLoading({ id: params.id, field: params.field }), isSynced: isCellSynced({ id: params.id, field: params.field }), isFailed: isCellFailed({ id: params.id, field: params.field }) })); },
            renderEditCell: (params) => { var _a; return (react_1.default.createElement(cells_1.AttributeTagsEditCell, { cellId: params.id, fieldName: params.field, value: params.formattedValue || [], row: params.row, attributeLabel: attributeId, productTreeNodeId: productTreeNodeIdForTaskView, autoOpen: (_a = isCellAutoOpen === null || isCellAutoOpen === void 0 ? void 0 : isCellAutoOpen(params.id, params.field)) !== null && _a !== void 0 ? _a : true, onSubmit: () => onCellSubmit === null || onCellSubmit === void 0 ? void 0 : onCellSubmit(params.id, params.field) })); },
        })));
    }, [
        getColumnFilterConfig,
        isCellFailed,
        isCellLoading,
        isCellSynced,
        isRowDisabled,
        t,
        productTreeNodeIdForTaskView,
        isCellAutoOpen,
        onCellSubmit,
    ]);
    const columns = (0, react_1.useMemo)(() => {
        const customColumns = constants_1.CUSTOM_PRODUCT_FIELDS.map((label) => ({
            id: (0, table_columns_1.createColumnId)(label, label === attributes_1.CustomProductAttributes.ClassificationProductType
                ? { isAIEnriched: true }
                : undefined),
            label,
        }));
        const reviewedColumn = {
            id: (0, table_columns_1.createColumnId)(products_table_constants_1.REVIEWED_COLUMN_ID),
            label: products_table_constants_1.REVIEWED_COLUMN_ID,
        };
        const explanationColumn = {
            id: (0, table_columns_1.createColumnId)(products_table_constants_1.EXPLANATION_COLUMN_ID),
            label: products_table_constants_1.EXPLANATION_COLUMN_ID,
        };
        const tableColumns = [];
        attributes
            .concat(customColumns)
            .concat([reviewedColumn, explanationColumn])
            .forEach((attributeColumn) => {
            var _a;
            const { id, isEditable } = attributeColumn;
            if (products_table_constants_1.TASK_REVIEW_BASE_COLUMNS.includes(id) || checkIsColumnSelected(id)) {
                const { label: attributeId, dataMeta } = (_a = (0, table_columns_1.parseColumnId)(id)) !== null && _a !== void 0 ? _a : {};
                const { isMeasure } = dataMeta;
                const columnConfig = productsTableColumnsConfig.find((columnConfig) => columnConfig.field === id);
                const isAttributeEditable = isEditable || (columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.editable);
                const pathPrefix = isMeasure ? product_table_1.MEASURE_PATH : product_table_1.LABEL_PATH;
                const column = createColumn(attributeColumn, columnConfig, attributeId, dataMeta, isAttributeEditable, pathPrefix);
                tableColumns.push(column);
            }
        });
        return tableColumns;
    }, [
        attributes,
        checkIsColumnSelected,
        createColumn,
        productsTableColumnsConfig,
    ]);
    const orderedColumns = (0, react_1.useMemo)(() => {
        const columnMap = new Map(columns.map((column) => [column.field, column]));
        return columnsOrder
            .map((id) => columnMap.get(id))
            .filter((column) => Boolean(column));
    }, [columns, columnsOrder]);
    return {
        tableColumns: {
            columns: orderedColumns,
            isLoading,
            error: error === null || error === void 0 ? void 0 : error.message,
            actions: {
                onChangeColumns: actions.onChangeColumns,
                setOrder: actions.setOrder,
            },
            selection: {
                excludedColumns,
                excludedLabelColumns,
                excludedMeasureColumns,
                selectAllMode,
                filterOptions,
            },
            order: {
                columnsOrder,
            },
            isCellLoading,
        },
    };
};
exports.useTaskProductsTableConfig = useTaskProductsTableConfig;
